// extracted by mini-css-extract-plugin
module.exports = {"TeamMemberImage":"styles_TeamMemberImage__qNFMz","height":"styles_height__yu07E"};